import { from } from 'rxjs'

import { CustomerAPI, FileAPI, KongCustomerAPI } from 'api'
import { rxCheckStatus, rxPluckData, rxRetryWithBackoff } from 'utils/api'

export const api = {
  createProfile(userId) {
    return from(CustomerAPI.post(`/users/${userId}/profile`, {})).pipe(
      rxCheckStatus()
    )
  },
  updateProfile(userId, operations) {
    return from(CustomerAPI.patch(`/users/${userId}/profile`, operations)).pipe(
      rxCheckStatus(),
      rxRetryWithBackoff()
    )
  },
  fetchProfile(userId) {
    return from(CustomerAPI.get(`/users/${userId}/profile`)).pipe(
      rxCheckStatus(),
      rxRetryWithBackoff()
    )
  },
  checkUniqueHandle(handle) {
    return from(KongCustomerAPI.head(`/users/handle_check?handle=${handle}`))
  },
  upload(file) {
    const data = new FormData()
    data.append('file', file)
    return from(FileAPI.post('/upload', data, { raw: true, headers: {} })).pipe(
      rxCheckStatus(),
      rxRetryWithBackoff(),
      rxPluckData()
    )
  },
}
